export default function (nga, admin, menu) {
    var _ename = 'users';
    var _epretty = 'Users';
    var _entity = nga.entity(_ename);
    
    
    _entity.listView()
        .title(_epretty)
        .fields([
            nga.field('id').label('ID'),
            nga.field('name').label('Name').isDetailLink(true),
            nga.field('email').label('email').isDetailLink(true),
            nga.field('').label('').template('<kts-login-as user="entry.values"></kts-login-as>')
        
        ])
        .filters([
            nga.field('email').label('Email').pinned(true)
        ])
        .sortField('name')
        .sortDir('asc')
        .listActions(['edit', 'show']);

    _entity.showView()
        .title(_epretty)
        .fields([
            nga.field('id').label('ID'),,
            nga.field('name').label('Name').isDetailLink(true),
            nga.field('email').label('email').isDetailLink(true),
            nga.field('attributes', 'embedded_list') 
                .targetFields([ // which comment fields to display in the datagrid / form
                    nga.field('name'),
                    nga.field('pivot.language'),
                    nga.field('pivot.value')
                ])
        ]);
        
    _entity.editionView()
        .title('Edit ' + _epretty)
        .fields([,
            nga.field('name').label('Name').isDetailLink(true),
            nga.field('email').label('email').isDetailLink(true),
            nga.field('attributes', 'embedded_list') 
                .targetFields([ // which comment fields to display in the datagrid / form
                    nga.field('name').editable(false),
                    nga.field('pivot.language'),
                    nga.field('pivot.value')
                ])
        ]);
        
    _entity.creationView()
        .title('Create new ' + _epretty)
        .fields([,
            nga.field('name').label('Name').isDetailLink(true),
            nga.field('email').label('email').isDetailLink(true),
            nga.field('attributes', 'embedded_list') 
                .targetFields([ // which comment fields to display in the datagrid / form
                    nga.field('name').editable(false),
                    nga.field('pivot.language'),
                    nga.field('pivot.value')
                ])
        ]);

    admin.addEntity(_entity);
    
    menu.addChild(nga.menu(_entity).title(_epretty));
    
    return _entity;
}


// WEBPACK FOOTER //
// ./js/entities/user.js